import gameSet from '@/api/administrator/game-set'
import result from '@/api/administrator/game-confirm-result'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment()
    .add(1, 'Day')
    .format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to
      },
      attrubutes
    )
    return result.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return result.store(data)
  },
  update(context, { id, data }) {
    return result.update(id, data)
  },
  getGameSet(context) {
    return gameSet.get({
      params: {
        include: 'game_setting,game_set_result',
        fields: {
          game_sets:
            'game_set_name,game_set_id,result_date,close_time,game_setting_id'
        },
        filter: {
          current_date: new Date(),
          aviable_confirm: new Date(),
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  }
}
